import { reactive } from "vue";
import { AuthenticationDataModel, AuthenticationErrorModel } from "../models/authentication-models";

export const authenticationData = reactive<AuthenticationDataModel>({
    userName: "",
    password: "",
    pin: "",
    consents: [],
});

export const authenticationErrors = reactive<AuthenticationErrorModel>({
    phoneErrorMessage: "",
    passwordErrorMessage: "",
    pinErrorMessage: "",
    newPasswordErrorMessage: "",
    consentsRequireError: "",
});

const clearAuthenticationErrors = () => {
    authenticationErrors.phoneErrorMessage = "";
    authenticationErrors.passwordErrorMessage = "";
    authenticationErrors.pinErrorMessage = "";
    authenticationErrors.newPasswordErrorMessage = "";
};

export default function useAuthenticationData() {
    return {
        clearAuthenticationErrors,
    };
}